import { render, staticRenderFns } from "./paper-invoice.vue?vue&type=template&id=d67ce1e6"
import script from "./paper-invoice.vue?vue&type=script&lang=js"
export * from "./paper-invoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports